import { useIntl } from 'react-intl';

export const useCreditBalanceMessages = () => {
  const intl = useIntl();

  const ERROR_TOOLTIP = intl.formatMessage({
    id: 'CreditBalanceHooks.errorTooltip',
    defaultMessage:
      'This number value cannot be displayed due to a system error. Check again in a few minutes or contact support for assistance.',
    description:
      'Error tooltip message when credit balance cannot be displayed',
  });

  const ERROR_ESTIMATION_MESSAGE = intl.formatMessage({
    id: 'CreditBalanceHooks.errorEstimationMessage',
    defaultMessage:
      'An error occurred while estimating the cost. Please update your scope or refresh the page.',
    description: 'Error message when cost estimation fails',
  });

  return {
    ERROR_TOOLTIP,
    ERROR_ESTIMATION_MESSAGE,
  };
};
